// Administração > Conta & Integrações > Contrato. Backend próprio
// (2026-08-28), mesma permissão granular de identidade visual/integrações
// (administracao.conta_integracoes, ver requirePermission em
// permission.guard.ts no backend).
import { gpsDriveDelete, gpsDriveGet, gpsDrivePost, gpsDrivePut, gpsDriveUpload } from "@/lib/api/gpsdrive-client";

export interface ContractTemplate {
  id: string;
  title: string;
  content: string;
  createdAt: string;
  updatedAt: string;
}

export interface UpsertContractTemplateInput {
  title: string;
  content: string;
}

export type ContractSignatoryRole = "signatario" | "testemunha";

export interface ContractSignatory {
  id: string;
  name: string;
  role: ContractSignatoryRole;
  cpfCnpj: string | null;
  email: string | null;
  phone: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface UpsertContractSignatoryInput {
  name: string;
  role: ContractSignatoryRole;
  cpfCnpj?: string | null;
  email?: string | null;
  phone?: string | null;
}

// Administração → Contrato → Dados da empresa (2026-10-14): cabeçalho do
// contrato (PDF e página de assinatura). Sem nome = nome da empresa; sem
// logo próprio = logo da Identidade Visual.
export interface ContractCompany {
  name: string;
  document: string;
  phone: string;
  email: string;
  address: string;
  website: string;
  logoUrl: string | null;
  customLogo: boolean;
}

export type ContractCompanyInput = Omit<ContractCompany, "logoUrl" | "customLogo">;

export const gpsDriveContractsService = {
  getCompany: () => gpsDriveGet<ContractCompany>("/api/v1/admin/contract-company"),
  saveCompany: (input: ContractCompanyInput) => gpsDrivePut<ContractCompany>("/api/v1/admin/contract-company", input),
  uploadCompanyLogo: (file: File) => gpsDriveUpload<ContractCompany>("/api/v1/admin/contract-company/logo", file),
  removeCompanyLogo: () => gpsDriveDelete<ContractCompany>("/api/v1/admin/contract-company/logo"),

  listTemplates: () => gpsDriveGet<ContractTemplate[]>("/api/v1/admin/contract-templates"),
  createTemplate: (input: UpsertContractTemplateInput) =>
    gpsDrivePost<ContractTemplate>("/api/v1/admin/contract-templates", input),
  updateTemplate: (id: string, input: UpsertContractTemplateInput) =>
    gpsDrivePut<ContractTemplate>(`/api/v1/admin/contract-templates/${id}`, input),
  deleteTemplate: (id: string) => gpsDriveDelete<void>(`/api/v1/admin/contract-templates/${id}`),

  listSignatories: () => gpsDriveGet<ContractSignatory[]>("/api/v1/admin/contract-signatories"),
  createSignatory: (input: UpsertContractSignatoryInput) =>
    gpsDrivePost<ContractSignatory>("/api/v1/admin/contract-signatories", input),
  updateSignatory: (id: string, input: UpsertContractSignatoryInput) =>
    gpsDrivePut<ContractSignatory>(`/api/v1/admin/contract-signatories/${id}`, input),
  deleteSignatory: (id: string) => gpsDriveDelete<void>(`/api/v1/admin/contract-signatories/${id}`),
};
